import React from 'react';

const Icon = ({ style="fas", icon, className='', title, onClick }) =>
  <i className={`${style} fa-${icon} ${className}`} title={title} onClick={onClick} />

  export default Icon;